import React, { Component } from "react";
import { Map, TileLayer, Popup, Marker, withLeaflet, LayersControl } from "react-leaflet";
import Paper from '@material-ui/core/Paper';

const MyMarker = props => {

    const initMarker = ref => {
        if (ref) {
            ref.leafletElement.openPopup()
        }
    }

    return <Marker ref={initMarker} {...props} />
}

class MapSelector extends Component {
    constructor(props) {
        super(props);

        this.state = !this.props.selected.lat?{currentPos: null}:{currentPos:this.props.selected};

        this.handleClick = this.handleClick.bind(this);
    }
    state= {anchorEl:null, setAnchorEl: null}

    handlePopoverOpen = (event) => {
        this.setAnchorEl(event.currentTarget);
    };

    handlePopoverClose = () => {
        this.setAnchorEl(null);
    };
    
    open = Boolean(this.anchorEl);
    handleClick(e) {

        this.props.select(e.latlng)
        this.setState({ currentPos: e.latlng });
    }
    render() {
        return (
            <Paper style={{ height: "100%", width: "100%" }}>
                <Map
                    style={{ height: "100%", width: "100%" }}
                    center={!this.props.selected.lat?this.props.center:this.props.selected}
                    zoom={this.props.zoom}
                    onClick={this.handleClick}
                >
                    <LayersControl>
                        <LayersControl.BaseLayer name="Satelital" checked>
                            <TileLayer
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" // satelital
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer name="Base" >
                            <TileLayer
                                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" //base
                            />
                        </LayersControl.BaseLayer>
                    </LayersControl>
                    {this.state.currentPos && <MyMarker position={!this.props.selected.lat?this.state.currentPos:this.props.selected}>
                    </MyMarker>}
                
                </Map>
            </Paper>
        )
    }
}

export default MapSelector;